import { Box, CircularProgress } from '@mui/material'
import React from 'react'
import { useEffect, useState } from 'react'

import { useStore } from '../store'
import { IDENTITY_ACTIONS } from '../store/identity'
import { COMPANY_CONFIG_ACTIONS } from '../store/companyConfig'
import { authedAxios, apiClient, getCookie } from '../utils'
import useIsAdmin from '../hooks/useIsAdmin'
import SuperadminView from '../superadmin/SuperadminView'
import { useNavigate } from 'react-router-dom'

const EnsureLoggedIn = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const { dispatch, state } = useStore()

  const { identity } = state

  const { isSuperAdmin } = useIsAdmin()

  const logout = () => {
    setIsLoggedIn(false)
    apiClient.logout()
  }

  const getIdentity = () => {
    return authedAxios
      .get('/api/identity/current')
      .then((res) => {
        const { identity } = res.data

        if (!identity.id) return logout()

        apiClient.setUser(identity)

        dispatch({ type: IDENTITY_ACTIONS.SET_IDENTITY, identity })
        setIsLoggedIn(true)
      })
      .catch(() => {
        logout()
      })
  }

  const getCompanyConfig = () => {
    if (isSuperAdmin) {
      return setIsLoading(false)
    }
    return authedAxios
      .get('/api/company/config')
      .then((res) => {
        const { companyConfig } = res.data

        dispatch({
          type: COMPANY_CONFIG_ACTIONS.SET_COMPANY_CONFIG,
          companyConfig,
        })

        setIsLoading(false)
      })
      .catch((e) => {
        console.log('ERROR')
        console.log(e)
        logout()
      })
  }

  const checkForRefreshToken = () => {
    const token = getCookie('refresh_token')
    if (!token) {
      logout()
      return false
    }
    return true
  }

  useEffect(() => {
    if (!checkForRefreshToken()) return

    getIdentity()
  }, [])

  useEffect(() => {
    if (!identity) return
    getCompanyConfig()
  }, [identity])

  const navigate = useNavigate()
  useEffect(() => {
    if (isSuperAdmin) navigate('/superadmin')
  }, [isSuperAdmin])

  console.log({ isLoading })

  if (isSuperAdmin) return <SuperadminView />

  if (isLoading) return <CircularProgress />

  if (isLoggedIn && identity) return children

  return <CircularProgress />
}

export default EnsureLoggedIn
